<template>
  <footer>
    <div>
      <a href="">
        <img src="@/assets/image/logo.png" class="logo" />
      </a>
      <ul>
        <li>
          <a href="https://attelu.jp/" target="_blank">
            {{ $t('運営会社') }}
          </a>
        </li>
        <li>
          <a href="https://attelu.jp/company" target="_blank">
            {{ $t('採用情報') }}
          </a>
        </li>
        <li>
          <a href="https://attelu.jp/term/user" target="_blank">
            {{ $t('利用規約') }}
          </a>
        </li>
        <li>
          <a href="https://attelu.jp/privacy" target="_blank">
            {{ $t('個人情報保護方針') }}
          </a>
        </li>
      </ul>
    </div>
    <div>
      <img src="@/assets/image/copyright.png" class="copyright" />
    </div>
  </footer>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  data() {
    return {};
  }
});
</script>
<style lang="scss">
@import '~/assets/scss/common.scss';

footer {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  background: #f6f6f6;
  height: 196px;
  padding: 50px 60px;

  @include sp {
    flex-direction: column;
    padding: 50px 16px;
    height: 100%;
  }

  img.logo {
    width: auto;
    height: 25px;
  }

  img.copyright {
    width: auto;
    height: 11px;
  }

  a.scout {
    padding: 7px 0 6px 23px;
    font-size: 13px;
    color: #fff;
    width: 164px;
    height: 32px;
    position: relative;
    display: inline-block;
    background-image: url('~@/assets/image/footer-pop.png');
    background-size: contain;
    background-position: left center;
    background-repeat: no-repeat;
  }

  ul {
    list-style: none;
    margin-top: 40px;
    padding-left: 0;

    li {
      display: inline-block;
      padding-right: 30px;

      @include sp {
        display: block;
        padding-right: 0;
        line-height: 32px;
      }
    }
  }
}
</style>
